import { Box } from '@mui/material'
import { sizing } from '../../theme'

const viewportHeight = (headerHeight) => ({
  height: `calc(100vh - ${headerHeight + sizing.footer.height}px)`,
  '@supports (height: 100dvh)': {
    height: `calc(100dvh - ${headerHeight + sizing.footer.height}px)`
  }
})

const bodyStyle = {
  width: '100%',
  '@media (min-width: 350px)': {
    ...viewportHeight(sizing.header.height),
    marginTop: `${sizing.header.height}px`
  },
  '@media (max-width: 349px)': {
    ...viewportHeight(sizing.header.height * 0.8),
    marginTop: `${sizing.header.height * 0.8}px`
  },
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch'
}

const scrollSpacerStyle = {
  display: 'block',
  height: `${sizing.footer.height + 10}px`,
  flexShrink: 0,
  userSelect: 'none'
}

export const Body = (props) => {
  const { children } = props

  return (
    <Box
      className="companion-content"
      data-component="companion-content"
      sx={bodyStyle}
    >
      {children}
      <Box sx={scrollSpacerStyle} aria-hidden="true" />
    </Box>
  )
}
